import React, { useState, useEffect } from 'react';
import { Form, Input, Checkbox, Row, Col, Upload, Radio, Select, DatePicker, InputNumber, Popconfirm, message } from 'antd';
import { useSpeechRecognition } from 'react-speech-recognition'
import renderElement from './formAnswers/renderElementConsent';
import ImageComp from './formAnswers/imgComp';
import { horiLayout, layout } from '../commonImports/import1'

let horiLayoutCust = {
  labelCol: { span: 16 },
  wrapperCol: { span: 8 },
};

const helpTextStyles = `
.help-text-container img {
  max-width: 100% !important; /* Make sure images don't overflow their container */
  height: auto !important; /* Allow height to scale proportionally */
  max-height: 200px !important; /* Limit maximum height */
  object-fit: contain; /* Maintains aspect ratio */
}

@media (max-width: 768px) {
  .help-text-container img {
    max-height: 150px !important; /* Smaller height on tablets */
  }
}

@media (max-width: 480px) {
  .help-text-container img {
    max-height: 100px !important; /* Even smaller height on mobile phones */
  }
}
`;

const RenderResponseWithAnsChat = (props) => {
  const { transcript, resetTranscript, interimTranscript, finalTranscript, listening } = useSpeechRecognition();

  const [uploadList, setuploadList] = useState([])
  const [flag, setflag] = useState(null)
  const [submitDone, setsubmitDone] = useState(false)
  const [voiceInput, setvoiceInput] = useState(null)
  const [p, setp] = useState(props.record)
  const [loading, setloading] = useState(true)


/// ---------------------------------------
  // useEffect(() => {
  //   if (props.formReseted == true) {
  //     setsubmitDone(false)
  //   }
  // })

  
  let index = props.index;
  let form = props.form;

  // let name = `${index}-${p.slugValue}`;
  let name = `${p.slugValueNew}`;


  let elemType = p.questionType;
  let isRequired = p.isRequired;


   //========================= update option selection on image click 
   const updateFormValues = (area) => {
    // let name = p.slugValue;
    if (p['questionType'] == 'RADIO_BUTTON') {
      let val = {};
      val = { answer: area.name }
      form.setFieldsValue({
        [name]: val
      })
    }

    if (p['questionType'] == 'CHECK_BOX') {
      let valueField = form.getFieldsValue([name]);
      let fieldVal = valueField[name] ? valueField[name] : {}
      let val = fieldVal.answer

      if(val && val.length > 0 && !val.find((a)=>a == area.name)){
        val.push(area.name);
      }
      if(!val){
        val = [area.name]
      }
      
      fieldVal.answer = val;

      form.setFieldsValue({
        [name]: fieldVal
      })
    }
    if (props.rerenderCustom) {
      props.rerenderCustom(false)
    }
  }

  let width = '200px';
  if (window) {
    width = window.screen.width;
  }
  let right = 0;
  let left = 0;
  if (width > 650) {
    right = '20%';
    left = '20%'
  }

  if (props.chat == true && loading == true) {
    return 'loading...'
  }



let layObj = props.layout ? props.layout :  props.attachedQuestions && props.attachedQuestions.length > 0 ? 
layout : p.questionType == 'FREE_TEXT' && p.freeText.textInputType == 'MULTI_LINE' ? layout: p.questionType  == 'TABLE' ?  layout : 
(p.questionType == 'CHECK_BOX' || p.questionType == 'RADIO_BUTTON' ) ? layout  : {};

let showLabel = p.questionType == 'FILL_IN_BLANKS' || p.questionType == 'TABLE' ? false : true
// console.log(props.attachedQuestions)
  return (
    < >
      <style>{helpTextStyles}</style>
      <div style={{ marginBottom: 0 }}>
       
          <Form.Item 
          colon={false}
          className="consent-formItem" 
          style={{marginBottom:'10px'}} 
          labelAlign="left" 
          {...layObj}  
          label={showLabel == true ? <><span style={{ marginRight: "5px", fontSize: "10px", color:'#00003B' }}>
                              ■
                            </span>
<span style={{fontSize:'16px',color:'#00003B', fontWeight:'bold' }}>{p.questionTitle}</span></> : ''} 
          name={[name,'answer']} 
          rules={
            [
              { required: isRequired, message: 'Required' },
              ({ getFieldValue }) => ({
                validator: (rule, value) => {
                  if (value != undefined && value != null && value != '' && elemType == 'NUMBER') {
                      if (!value.toString().trim().match("^[0-9]+$")) {
                          return Promise.reject(`Characters are not allowed, please enter numeric value.`);
                      }
                  }
                return Promise.resolve();
              }
            })
            ]
            }>
            {renderElement(props, form, p,name, elemType,  uploadList, 
              {answers:true, attachedQuestions: props.attachedQuestions})}


          </Form.Item>
              {p.helpText &&
              // <p style={{fontSize:'12px',color:'grey',marginTop:'5px'}}>{p.helpText}</p>:''
              <div 
                className="help-text-container"
                style={{backgroundColor:'white', padding:'10px 0px', marginBottom:'10px', color:'#00003B' }} 
                dangerouslySetInnerHTML={{__html: p.helpText}}
              ></div>
              }

          {p.refImage && p.refImage != null &&
            <div style={{ marginBottom: 30 }}>
             <ImageComp p={p} updateFormValues={updateFormValues}/>
            </div>
          }

      </div>

    </>
  );

}

export default RenderResponseWithAnsChat;